// Plugins

// Local
import initUitKit from "./ui-kit.js";

window.initDom = ($wrapper) => {
    initUitKit($wrapper);

    $wrapper.querySelectorAll('[data-ui-kit-form]').forEach(async($item) => {
        const UiKitForm = await import('./partials/ui-kit-form');
        (new UiKitForm.default($item));
    });

}

(function() {
    window.initDom(document);
})();